__turbopack_context__.v({
  "className": "em2j-G_className",
  "variable": "em2j-G_variable",
});
